<div class="row selfcheckoutScreen demo">
  <div class="col-12">
    <div class="container-xl">
      <div class="row smt12">
        <div
          class="col-xs-12 col-sm-4 col-md-6 f-m"
          data-aos="fade-right"
          data-aos-duration="1000">
          <h4>TALK WITH INDUSTRY EXPERTS</h4>
          <h1 class="animated-heading f-p">
            <!-- <span *ngFor="let letter of headingArray; let i = index" [style.animationDelay]="i * animationDuration + 's'">
              {{ letter }}
            </span> -->
            Experience <br />
            <span>iKunnect</span><br />
            In Action
          </h1>
          <ul>
            <li>
              <img src="./../../assets/images/list-bg-4.png" alt="" />
              <strong>Unified Agent Workspace:</strong> All the tools and data
              necessary for agents are displayed on a single screen, offering
              full context for each customer interaction.
            </li>
            <li>
              <img src="./../../assets/images/list-bg-4.png" alt="" />
              <strong>Seamless Omnichannel Interactions:</strong> Watch how
              customer conversations transition effortlessly across channels
              while preserving all data and context, ensuring a consistent and
              efficient experience.
            </li>
            <!-- <li>
              <img src="./../../assets/images/list-bg-4.png" alt="" />
              Discover past success in improving productivity and customer satisfaction across various industries and regions.
            </li> -->
          </ul>
        </div>
        <div
          class="col-xs-12 col-sm-8 col-md-6 haveForm selfcheckout"
          data-aos="fade-left"
          data-aos-duration="1000">
          <div class="row">
            <form [formGroup]="form">
              <div class="col-12 inputB2">
                <h5 class="smb3">Schedule a consultation today!</h5>
                <div class="row">
                  <div class="col-xs-12 col-sm-6">
                    <label>First name*</label>
                    <input
                      class="form-control"
                      placeholder="First name*"
                      formControlName="firstName" />
                    <div
                      class="error-msg mt-1"
                      *ngIf="
                        f['firstName'].dirty &&
                        f['firstName'].hasError('required')
                      ">
                      First name is required.
                    </div>
                    <div
                      class="error-msg mt-1"
                      *ngIf="
                        f['firstName'].dirty &&
                        f['firstName'].hasError('pattern')
                      ">
                      First Name is only allow alpha characters.
                    </div>
                    <div
                      class="error-msg mt-1"
                      *ngIf="
                        f['firstName'].dirty &&
                        f['firstName'].hasError('maxlength')
                      ">
                      Maximum length of 40 characters exceeded.
                    </div>
                    <div
                      class="error-msg mt-1"
                      *ngIf="
                        f['firstName'].dirty &&
                        f['firstName'].hasError('minlength')
                      ">
                      Minimum 3 characters is required.
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <label>Last name*</label>
                    <input
                      class="form-control"
                      placeholder="Last name*"
                      formControlName="lastName" />
                    <div
                      class="error-msg mt-1"
                      *ngIf="
                        f['lastName'].dirty &&
                        f['lastName'].hasError('required')
                      ">
                      Last name is required.
                    </div>
                    <div
                      class="error-msg mt-1"
                      *ngIf="
                        f['lastName'].dirty && f['lastName'].hasError('pattern')
                      ">
                      Last Name is only allow alpha characters.
                    </div>
                    <div
                      class="error-msg mt-1"
                      *ngIf="
                        f['lastName'].dirty &&
                        f['lastName'].hasError('maxlength')
                      ">
                      Maximum length of 40 characters exceeded.
                    </div>
                    <div
                      class="error-msg mt-1"
                      *ngIf="
                        f['lastName'].dirty &&
                        f['lastName'].hasError('minlength')
                      ">
                      Minimum 3 characters is required.
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <label>Phone Number</label>
                    <input
                      class="form-control"
                      placeholder="Phone Number"
                      formControlName="phoneNumber" />
                    <div
                      class="error-msg mt-1"
                      *ngIf="
                        f['phoneNumber'].dirty &&
                        f['phoneNumber'].hasError('invalidPhoneNumber')
                      ">
                      Phone Number should be 10 digits long.
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <label>Business Email*</label>
                    <input
                      class="form-control"
                      placeholder="Business Email*"
                      formControlName="businessEmail" />
                    <div
                      class="error-msg mt-1"
                      *ngIf="
                        f['businessEmail'].dirty &&
                        f['businessEmail'].hasError('required')
                      ">
                      Business Email is required
                    </div>
                    <div
                      class="error-msg mt-1"
                      *ngIf="
                        f['businessEmail'].dirty &&
                        f['businessEmail'].hasError('pattern')
                      ">
                      Business Email is invalid
                    </div>
                    <div
                      class="error-msg mt-1"
                      *ngIf="
                        f['businessEmail'].dirty &&
                        f['businessEmail'].hasError('isVerify')
                      ">
                      Business Email address is not verified.
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <label>Company Name</label>
                    <input
                      class="form-control"
                      placeholder="Company Name"
                      formControlName="companyName" />
                    <div
                      class="error-msg mt-1"
                      *ngIf="
                        f['companyName'].dirty &&
                        f['companyName'].hasError('maxlength')
                      ">
                      Maximum length of 40 characters exceeded.
                    </div>
                    <div
                      class="error-msg mt-1"
                      *ngIf="
                        f['companyName'].dirty &&
                        f['companyName'].hasError('minlength')
                      ">
                      Minimum 3 characters is required.
                    </div>
                  </div>
                  <div class="col-xs-12">
                    <label
                      >Is there anything specific you would like to discuss? Let
                      us know and we will make sure to cover it during our
                      time.</label
                    >
                    <textarea
                      rows="7"
                      class="form-control"
                      placeholder="Country / Region"
                      formControlName="message"></textarea>
                    <div
                      class="error-msg mt-3 mb-0"
                      *ngIf="
                        f['message'].dirty && f['message'].hasError('maxlength')
                      ">
                      Maximum length of 200 characters exceeded.
                    </div>
                    <div
                      class="error-msg mt-3 mb-0"
                      *ngIf="
                        f['message'].dirty && f['message'].hasError('minlength')
                      ">
                      Minimum 3 characters is required.
                    </div>
                  </div>
                  <div class="col-xs-12 smt2">
                    <input
                      type="checkbox"
                      class="smb2 smr1"
                      formControlName="subscription" />
                    I would like to subscribe to the monthly newsletter.
                    <p class="sfont12 haveLink">
                      By submitting this form, you agree to our <a href=""
                        >Terms and Conditions</a
                      > and the processing of your personal data for this
                      purpose. By subscribing to our newsletter, you consent to
                      receive marketing communication from us. For more details,
                      see our <a href="">Privacy Notice.</a>
                    </p>
                  </div>
                  <div class="col-xs-12">
                    <button
                      type="button"
                      class="primaryBtn w-100"
                      [class]="!form.valid ? 'disabled' : ''"
                      [disabled]="!form.valid"
                      (click)="createADemo()">
                      Request a consultation
                      <div *ngIf="isLoading" class="spinner ml-1">
                        <mat-spinner [diameter]="20"></mat-spinner>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="col-xs-12 smt3 smb6 haveClients">
          <div class="row clients align-items-center justify-content-between">
            <div class="col-auto">
              <img
                src="assets/images/client-logo/jpmorgan.png"
                alt="JP Morgan" />
            </div>
            <div class="col-auto">
              <img src="assets/images/client-logo/lenovo.png" alt="Lenovo" />
            </div>
            <div class="col-auto">
              <img
                src="assets/images/client-logo/microsoft.png"
                alt="Microsoft" />
            </div>
            <div class="col-auto">
              <img src="assets/images/client-logo/samsung.png" alt="samsung" />
            </div>
            <div class="col-auto">
              <img
                src="assets/images/client-logo/wallmart.png"
                alt="wallmart" />
            </div>
            <div class="col-auto">
              <img src="assets/images/client-logo/amazon.png" alt="amazon" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-transform-customer-service class="spa0 col-12" />
</div>
